<template>
  <div>
    <a-modal
      :centered="true"
      :dialog-style="{ margin: '0px', width: '100px !important' }"
      v-model="visible"
      title="Account Not Verified"
      on-ok="handleOk"
    >
      <template slot="footer">
        <!-- <a-button
          class="dovemed-button primary-border hyper-link"
          @click="handleCancel"
          :style="{
            border: '1px solid ' + getPrimaryColor(),
            color: getPrimaryColor(),
            background: '#fff'
          }"
        >
          Return
        </a-button> -->
        <a-button
          :style="{ background: '#2a71d4' }"
          class="dovemed-button font-white ml-4 primary-button treatment-button "
          @click="handleOk"
        >
          Close
        </a-button>
      </template>
      <div class="text-big">
        You are yet to confirm your email address!
      </div>
      <p class="text-small">
        In order to perform this action, please check your email and click on
        the link to verify your account.
      </p>
    </a-modal>
  </div>
</template>
<script>
export default {
  name: "AccVerifyModal",
  data() {
    return {
      loading: false,
      visible: false
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      this.loading = true;
      setTimeout(() => {
        this.visible = false;
        this.loading = false;
      }, 1000);
    },
    handleCancel(e) {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.treatment-button {
  @media screen and (max-width: 900px) {
    padding: 10px 50px;
  }

  @media screen and (max-width: 600px) {
    padding: 10px 25px;
  }
}
.dovemed-button {
  padding: 12px 45px;
}
.text-big {
  font-size: 24px;
  line-height: 36px;
  color: rgb(6, 43, 84);
  opacity: 0.87;
  margin: 0px;
}
.text-small {
  color: rgb(51, 51, 51);
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/AccountNotVerifiedWarning.vue